import type { content } from "~/types/api/client/webpage/content";
import type { contentlist } from "~/types/api/client/webpage/contentlist";

export class ContentAPI {
    clientId: number;
    websiteId: number;
    webpageId: number

    constructor(clientId: number, websiteId: number, webpageId: number) {
        this.clientId = clientId
        this.websiteId = websiteId;
        this.webpageId = webpageId;
    }

    async getContent(contentid: number): Promise<content> {
        const response = await $fetch<content>(`/api/client/webpage/content`, {
            headers:useRequestHeaders(['cookie']),
            query: {
                clientid: this.clientId,
                websiteid: this.websiteId,
                webpageid: this.webpageId,
                contentid: contentid
            }
        })
        return response
    }

    async getContentList(webpageid?: number): Promise<contentlist[]> {

        interface contentlistQuery {
            clientid: number,
            websiteid: number,
            webpageid?: number
        }

        const query: contentlistQuery = {
            clientid: this.clientId,
            websiteid: this.websiteId,
        }

        if(webpageid) {
            query.webpageid = webpageid
        }

        const response = await $fetch<contentlist[]>(`/api/client/webpage/contentlist`, {
            headers:useRequestHeaders(['cookie']),
            query: query
        })
        return response
    }
}